module.exports = __webpack_public_path__ + "static/media/DSCF0288-qRqoiYgs.64688e5a.JPG";